/* eslint-disable camelcase */

class Controller {
  constructor($mdDialog, $injector, Events, id, cashCollectionMeta) {
    "ngInject";

    this.$mdDialog = $mdDialog;
    this.Events = Events;
    this.Bookings = $injector.get("Bookings");
    this.bookingId = id;
    this.cashCollectionResolver = "";

    this.successNotificationEvent = this.Events.eventsType.onShowSuccessNotification;
    this.errorNotificationEvent = this.Events.eventsType.onShowErrorNotification;
    this.cashCollectionResolveRadio = false;
    this.cashCollectionResolveSelection = () => {
      this.cashCollectionResolveRadio = true;
    };

    this.cashCollectionMeta = cashCollectionMeta;
  }

  confirm() {
    const resolveInFavorOfCaptain = {
      is_captain_exempted: true,
    };

    const resolveInFavorOfCustomer = {
      is_captain_exempted: false,
    };

    const resolver =
      this.cashCollectionResolver === "captain"
        ? resolveInFavorOfCaptain
        : resolveInFavorOfCustomer;
    this.Bookings.cashCollectionResolve(this.bookingId, resolver)
      .$promise.then((response) => {
        this.cashCollectionMeta = response.cash_collection_meta;
        this.Events.emit(this.successNotificationEvent, {
          message: "Cash Collection Resolved Successfully",
        });
        this.close();
      })
      .catch((err) => {
        const messageData = err.data;
        this.Events.emit(this.errorNotificationEvent, {
          message: `Error Resolving Cash Collection ${
            messageData ? messageData.message : ""
          }`,
        });
        this.close();
      });
  }
  close() {
    this.$mdDialog.cancel();
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/pages/booking/cashCollectionDiag/cashCollectionDialog.controller.js